import { render, staticRenderFns } from "./ConventionCaActivityItem.vue?vue&type=template&id=70d1b93c&scoped=true"
import script from "./ConventionCaActivityItem.vue?vue&type=script&lang=js"
export * from "./ConventionCaActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ConventionCaActivityItem.vue?vue&type=style&index=0&id=70d1b93c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1b93c",
  null
  
)

export default component.exports